interface ISiteElementHtmlViewConfig {
    actionLink: IActionLink;
}

class SiteElementHtmlView
    extends QueryElement<HTMLElement> {
    
    private _eventRefresh: (e: CustomEvent<any>) => any;
    private _card: SiteCard;
    private _config: ISiteElementHtmlViewConfig;

    constructor(
        card: SiteCard,
        elem: HTMLElement) {

        super(elem);
        let path = this.getAttr('data-path');

        this._card = card;
        this._config = card.Model.get((path && SiteModel.split(path)) || []) as ISiteElementHtmlViewConfig;

        this._eventRefresh = card.on("qts.refresh", async (e: CustomEvent) => {
            this.refresh();
        });

        this.getView();
    }

    async refresh() {
        // TODO: Only refresh when visible (same as search)
        await this.getView();
    }

    async getView() {
        let queryRequest = await new QueryRequest(
            SiteAction.toLink(this._config.actionLink.actionInfo),
            this._config.actionLink.model ?
            {
                contentType: 'json',
                data: JSON.stringify(this._config.actionLink.model),
                method: 'post'
            }
            : undefined
        ).request();

        this.setHtml(await queryRequest.text());
    }
    
    async remove(removeInner = true) {
        await super.remove(removeInner);

        this._card.off("qts.refresh", this._eventRefresh);
    }
}